import React from 'react';
import cs from 'classnames';

import s from './styles.module.less';

const ScheduleDay = ({ title, onClick, isEmpty, className, isList = false }) => {
  return (
    <button
      className={cs(className, s.day, { [s.empty]: isEmpty, [s.filled]: !isEmpty, [s.listDay]: isList })}
      onClick={onClick}
      type="button"
    >
      {title}
    </button>
  );
};

export default ScheduleDay;
